import { render, staticRenderFns } from "./EmailRestartPasswordSended.vue?vue&type=template&id=fb3b1d58&"
import script from "./EmailRestartPasswordSended.vue?vue&type=script&lang=js&"
export * from "./EmailRestartPasswordSended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports